var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{attrs:{"data-testid":"diagram-performance-warning","primary-button-text":_vm.$options.i18n.buttonText,"variant":"warning"},on:{"dismiss":function($event){return _vm.$emit('close-alert')},"primaryAction":function($event){return _vm.$emit('show-image')}}},[_vm._v("\n  "+_vm._s(_vm.$options.i18n.bodyText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }